// extracted by mini-css-extract-plugin
export default {"productGallery":"dJ-z","inQuickShop":"eJ-z"};